exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.partisan-lean-cell .bar-stack.small {\n  height: 8px;\n}\n.lean-value {\n  font-weight: 800;\n}\n", ""]);

// exports
